// extracted by mini-css-extract-plugin
export default {"eventPageHero":"eventPageHero_eventPageHero__QCMu3","wrapper":"eventPageHero_wrapper__4HAFk","contactWrap":"eventPageHero_contactWrap__nNLnK"};